import { CheckboxBlankBadgeOutlineIcon } from './CheckboxBlankBadgeOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 219B8956-E48B-4D11-9257-422E563955DB
 * name checkbox-blank-badge-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-badge-outline.svg
 * tags
 * - Notification 
 * - Form 
 */
export const AppNotificationOutlineIcon = CheckboxBlankBadgeOutlineIcon;
export default AppNotificationOutlineIcon